import {MAX_SUGGESTIVE_SELLING_CHAIN_DEPTH} from '../constants';

export function shouldOpenSuggestiveSelling(
    crossSalesCount: number,
    partId: number,
    visitedPartIds: Set<number>,
    depth: number,
): boolean {
    return (
        crossSalesCount > 0
        && !visitedPartIds.has(partId)
        && depth < MAX_SUGGESTIVE_SELLING_CHAIN_DEPTH
    );
}
